var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTasks(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3.69697C9 2.75636 9.78 2 10.75 2H16.25C17.22 2 18 2.75636 18 3.69697V4.66667C18 5.60727 17.22 6.36364 16.25 6.36364H10.75C9.78 6.36364 9 5.60727 9 4.66667V3.69697ZM10.75 3.45455C10.61 3.45455 10.5 3.56121 10.5 3.69697V4.66667C10.5 4.80242 10.61 4.90909 10.75 4.90909H16.25C16.39 4.90909 16.5 4.80242 16.5 4.66667V3.69697C16.5 3.56121 16.39 3.45455 16.25 3.45455H10.75Z",
    fill: "#676879"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 9.51533C2 8.57472 2.78 7.81836 3.75 7.81836H16.25C17.22 7.81836 18 8.57472 18 9.51533V10.485C18 11.4256 17.22 12.182 16.25 12.182H3.75C2.78 12.182 2 11.4256 2 10.485V9.51533ZM3.75 9.2729C3.61 9.2729 3.5 9.37957 3.5 9.51533V10.485C3.5 10.6208 3.61 10.7275 3.75 10.7275H16.25C16.39 10.7275 16.5 10.6208 16.5 10.485V9.51533C16.5 9.37957 16.39 9.2729 16.25 9.2729H3.75Z",
    fill: "#676879"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 15.3337C2 14.3931 2.78 13.6367 3.75 13.6367H16.25C17.22 13.6367 18 14.3931 18 15.3337V16.3034C18 17.244 17.22 18.0004 16.25 18.0004H3.75C2.78 18.0004 2 17.244 2 16.3034V15.3337ZM3.75 15.0913C3.61 15.0913 3.5 15.1979 3.5 15.3337V16.3034C3.5 16.4391 3.61 16.5458 3.75 16.5458H16.25C16.39 16.5458 16.5 16.4391 16.5 16.3034V15.3337C16.5 15.1979 16.39 15.0913 16.25 15.0913H3.75Z",
    fill: "#676879"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42023 3L4.54614 5.99916M4.54336 5.99996L3 4.99995",
    stroke: "#676879",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.8fe2c86b.svg";
export { ForwardRef as ReactComponent };